import React, { useState, useEffect } from 'react';
import axios from 'axios';
import WholeLoading from '../../../component/common/loading/WholeLoading';

import '../../../css/popup.css';
import * as Icons from '../../../images/icons/icons_component';
import * as Theme from '../../../images/icons/icons_theme';

const TrmsV3_popup = () => {

    const [data, setData] = useState({});
    const [isWholeLoading, setIsWholeLoading] = useState(false);

    const popupData = async (sendData) => {
        try {
            const response = await axios.get('/trmsapi/oesangweb/bdtrms_detail_v3.do', {
                params: sendData
            });
            setData(response.data || {});
            setIsWholeLoading(false);
        } catch (e) {
            console.error('❌ 팝업 데이터 로딩 오류', e);
        }
    };

    useEffect(() => {
        const storedData = localStorage.getItem('trmsData');
        if (storedData) {
            const sendData = JSON.parse(storedData);
            setIsWholeLoading(true);
            popupData(sendData);
        }
    }, []);

    // 구조 분해 및 기본값 할당으로 undefined 방지
    const {
        detail = [],
        pgynlist = [],
        pfynlist = [],
        phynlist = [],
        paynlist = [],
        preslist = [],
        ptynlist = [],
        fhpylist = [],
        resplist = [],
        vbralist = [],
        voxalist = [],
        ngt5list = [],
        ngt1list = [],
        ngt2list = [],
        ngt3list = [],
        bd32list = [],
        emihsdmdlist = [],
        clynlist = [],
        onynlist = [],
        emihcltplist = [],
        ngn5list = [],
        ngn1list = [],
        ngn2list = [],
        ngn3list = [],
        emihdgotlist = [],
        emihtrhtlist10 = [],
        emihtrhtlist20 = [],
        emihtrhtlist30 = [],
        emihtrhtlist31 = [],
        emihtrhtlist40 = [],
        emihtrhtlist50 = [],
        cp24list = [],
        emihdgdclist = [],
        thpylist = [],
        emihdgdtlist = [],
        emihaisilist1 = [],
        emihaisilist2 = [],
        emihaisilist3 = [],
        emihaisilist4 = [],
        emihaisilist5 = [],
        emihaisilist6 = []
    } = data;

    return (
        <div className='popup_container'>
            {isWholeLoading ? <WholeLoading /> : ''}
            <div className='btn_container flex justify-between'>
                <div>
                    <div className='flex items-center bold'>
                        <Theme.Dot16 className='tr_non' />
                        <span className='ml-1'>어두운 색 항목은 미 전송 처리된 항목입니다.</span>
                    </div>
                    <div className='flex items-center bold'>
                        <Theme.Dot16 className='tr_row' />
                        <span className='ml-1'>밝은 색 항목은 표준등록체계 연동 데이터 입니다.<span className='ml-1 co_red'>수정을 원하시면 표준등록체계 입력 담당자</span>에게 문의하십시오.</span>
                    </div>
                </div>
                <button onClick={() => window.close()} className='comm_btn bg_co_black'>닫기</button>
            </div>
            <div className='popup_title'>
                <table summary='자료상태값'>
                    <colgroup>
                        <col width='13%' />
                        <col width='7%' />
                        <col width='9%' />
                        <col width='12%' />
                        <col width='9%' />
                        <col width='10%' />
                        <col width='10%' />
                        <col width='10%' />
                        <col width='10%' />
                        <col width='10%' />
                    </colgroup>
                    <tbody>
                        <tr>
                            <th>외상등록체계 자료처리상태</th>
                            <td>{detail?.TRMSSTAT}</td>
                            <th>전송일시</th>
                            <td>{detail?.TRMSWKDTM}</td>
                            <th>표준등록체계상태</th>
                            <td>{detail?.PTMISTAT}</td>
                            <th>연동 후 제외 구분</th>
                            <td>{detail?.TRMSEXYN || '-'}</td>
                            <th>외상환자 제외사유</th>
                            <td>{detail?.TRMSSTATP || '-'}
                                {detail?.TRMSSTATX && detail?.TRMSSTATX !== '-' ? (<span>({detail?.TRMSSTATX})</span>) : ('')}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='trms_v_container'>
                <div className='trms_v_wrapper'>
                    <div id='bdtrms_emog' className='trms_v_section'>
                        <div className='trms_v_subject'>&nbsp;1. 의료기관 정보</div>
                        <table summary='의료기관 정보'>
                            <colgroup>
                                <col width='15%' />
                                <col width='18%' />
                                <col width='15%' />
                                <col width='18%' />
                                <col width='15%' />
                                <col width='18%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th className='nedis'>의료기관명</th>
                                    <td>{detail?.EMOGDESC}</td>
                                    <th className='nedis'>요양기관번호</th>
                                    <td>{detail?.PTMIHSCD}</td>
                                    <th className='nedis'>응급의료기관코드</th>
                                    <td>{detail?.TRMSEMCD}</td>
                                </tr>
                                <tr>
                                    <th className='nedis'>의무기록번호</th>
                                    <td>{detail?.PTMIMASK}</td>
                                    <th className='nedis'>주된 진료를 받은<br />응급의료센터</th>
                                    <td>{detail?.PTMIMDCD}</td>
                                    <th>환자분류</th>
                                    <td>{detail?.TRMSPTGB}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div id='bdtrms_human' className='trms_v_section'>
                        <div className='trms_v_subject mt-6'>&nbsp;2. 인구통계학적 정보</div>
                        <table summary='인구통계학적 정보'>
                            <colgroup>
                                <col width='15%' />
                                <col width='18%' />
                                <col width='15%' />
                                <col width='18%' />
                                <col width='15%' />
                                <col width='18%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th className='nedis'>성명</th>
                                    <td>{detail?.PTMINAME}</td>
                                    <th className='nedis'>연령</th>
                                    <td>{detail?.PTMIBRTD}</td>
                                    <th className='nedis'>성별</th>
                                    <td>{detail?.PTMISEXX}</td>
                                </tr>
                                <tr>
                                    <th>환자국적</th>
                                    <td>{detail?.TRMSNATN} {detail?.TRMSNATX}</td>
                                    <th className='not_sent'>거주지역</th>
                                    <td colSpan='3'>{detail?.TRMSADR1} {detail?.TRMSADR2} {detail?.TRMSADR3}</td>
                                </tr>
                                <tr>
                                    <th>미거주자</th>
                                    {detail?.TRMSNORE === null ? (<td>-</td>) : (<td>{detail?.TRMSNORE || '-'}</td>)}
                                    <td colSpan='4'></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div id='bdtrms_damaged' className='trms_v_section'>
                        <div className='trms_v_subject mt-6'>&nbsp;3. 손상관련 정보</div>
                        <table summary='손상 관련 정보'>
                            <colgroup>
                                <col width='15%' />
                                <col width='18%' />
                                <col width='15%' />
                                <col width='18%' />
                                <col width='15%' />
                                <col width='18%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th className='nedis'>질병 여부</th>
                                    <td>{detail?.PTMIDGKD}</td>
                                    <th className='nedis'>의도성 여부</th>
                                    <td>{detail?.PTMIARCF}</td>
                                    <th>손상유형</th>
                                    <td>{detail?.TRMSDMTP} ({detail?.TRMSDMTX})</td>
                                </tr>
                                <tr>
                                    <th>사고종류</th>
                                    <td colSpan='5'>
                                        <span>{detail?.TRMSACKN || '-'}</span> <span className='not_sent px-1'>추락높이:({detail?.TRMSACFL})m</span> 기타:({detail?.TRMSACTX})
                                    </td>
                                </tr>
                                <tr>
                                    <th className='not_sent' rowSpan='2'>보호장구</th>
                                    <td colSpan='5'>
                                        {pgynlist.map((item, index) => (
                                            <span key={index}>
                                                <input
                                                    type='radio'
                                                    disabled
                                                    name='trmspgyn'
                                                    id={`trmspgyn${index + 1}`}
                                                    value={item.bscdminr}
                                                    checked={detail?.TRMSPGYN === item.bscdminr}
                                                    readOnly // <- React controlled input을 위해 필요
                                                />
                                                <label htmlFor={`trmspgyn${index + 1}`}>{item.bscddesc}</label>
                                            </span>
                                        ))}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan='5'>
                                        <input
                                            type='checkbox'
                                            name='trmspg01'
                                            id='trmspg01'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPG01 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspg01'>안전벨트</label>

                                        <input
                                            type='checkbox'
                                            name='trmspg02'
                                            id='trmspg02'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPG02 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspg02'>구명조끼</label>

                                        <input
                                            type='checkbox'
                                            name='trmspg03'
                                            id='trmspg03'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPG03 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspg03'>헬멧</label>

                                        <input
                                            type='checkbox'
                                            name='trmspg04'
                                            id='trmspg04'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPG04 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspg04'>고글</label>

                                        <input
                                            type='checkbox'
                                            name='trmspg05'
                                            id='trmspg05'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPG05 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspg05'>카시트</label>

                                        <input
                                            type='checkbox'
                                            name='trmspg06'
                                            id='trmspg06'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPG06 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspg06'>에어백</label>

                                        <input
                                            type='checkbox'
                                            name='trmspg07'
                                            id='trmspg07'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPG07 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspg07'>무릅 및 관절보호대</label>

                                        <input
                                            type='checkbox'
                                            name='trmspg09'
                                            id='trmspg09'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPG09 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspg09'>미상</label>

                                        <input
                                            type='checkbox'
                                            name='trmspg08'
                                            id='trmspg08'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPG08 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspg08'>기타 ({detail?.TRMSPGTX})</label>
                                    </td>
                                </tr>
                                <tr>
                                    <th rowSpan='2'>추락사고 보호장구</th>
                                    <td colSpan='5'>
                                        {pfynlist.map((item, index) => (
                                            <React.Fragment key={index}>
                                                <input
                                                    type='radio'
                                                    disabled
                                                    name='trmspfyn'
                                                    id={`trmspfyn${index + 1}`}
                                                    value={item.bscdminr}
                                                    checked={detail?.TRMSPFYN === item.bscdminr}
                                                    readOnly
                                                />
                                                <label htmlFor={`trmspfyn${index + 1}`}>{item.bscddesc}</label>
                                            </React.Fragment>
                                        ))}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan='5'>
                                        <input
                                            type='checkbox'
                                            name='trmspf11'
                                            id='trmspf11'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPF11 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspf11'>안전대</label>

                                        <input
                                            type='checkbox'
                                            name='trmspf12'
                                            id='trmspf12'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPF12 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspf12'>안전화</label>

                                        <input
                                            type='checkbox'
                                            name='trmspf13'
                                            id='trmspf13'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPF13 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspf13'>장갑</label>

                                        <input
                                            type='checkbox'
                                            name='trmspf03'
                                            id='trmspf03'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPF03 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspf03'>헬멧</label>

                                        <input
                                            type='checkbox'
                                            name='trmspf04'
                                            id='trmspf04'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPF04 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspf04'>고글</label>

                                        <input
                                            type='checkbox'
                                            name='trmspf07'
                                            id='trmspf07'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPF07 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspf07'>무릎 및 관절보호대</label>

                                        <input
                                            type='checkbox'
                                            name='trmspf08'
                                            id='trmspf08'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPF08 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspf08'>기타 ({detail?.TRMSPFTX})</label>
                                    </td>
                                </tr>
                                <tr>
                                    <th rowSpan='2'>기타사고 보호장구</th>
                                    <td colSpan='5'>
                                        {phynlist.map((item, index) => (
                                            <React.Fragment key={index}>
                                                <input
                                                    type='radio'
                                                    disabled
                                                    name='trmsphyn'
                                                    id={`trmsphyn${index + 1}`}
                                                    value={item.bscdminr}
                                                    checked={detail?.TRMSPHYN === item.bscdminr}
                                                    readOnly
                                                />
                                                <label htmlFor={`trmsphyn${index + 1}`}>{item.bscddesc}</label>
                                            </React.Fragment>
                                        ))}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={5}>
                                        <input
                                            type='checkbox'
                                            name='trmsph11'
                                            id='trmsph11'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPH11 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmsph11'>안전대</label>

                                        <input
                                            type='checkbox'
                                            name='trmsph12'
                                            id='trmsph12'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPH12 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmsph12'>안전화</label>

                                        <input
                                            type='checkbox'
                                            name='trmsph13'
                                            id='trmsph13'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPH13 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmsph13'>장갑</label>

                                        <input
                                            type='checkbox'
                                            name='trmsph02'
                                            id='trmsph02'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPH02 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmsph02'>구명조끼</label>

                                        <input
                                            type='checkbox'
                                            name='trmsph03'
                                            id='trmsph03'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPH03 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmsph03'>헬멧</label>

                                        <input
                                            type='checkbox'
                                            name='trmsph04'
                                            id='trmsph04'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPH04 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmsph04'>고글</label>

                                        <input
                                            type='checkbox'
                                            name='trmsph07'
                                            id='trmsph07'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPH07 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmsph07'>무릎 및 관절보호대</label>

                                        <input
                                            type='checkbox'
                                            name='trmsph08'
                                            id='trmsph08'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPH08 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmsph08'>기타 ({detail?.TRMSPHTX})</label>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='nedis'>교통사고 보호장구</th>
                                    <td colSpan={5}>
                                        <input
                                            type='checkbox'
                                            name='ptmitsbt'
                                            id='ptmitsbt'
                                            disabled
                                            value='Y'
                                            checked={detail?.PTMITSBT === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspg01'>안전벨트</label>

                                        <input
                                            type='checkbox'
                                            name='ptmitscs'
                                            id='ptmitscs'
                                            disabled
                                            value='Y'
                                            checked={detail?.PTMITSCS === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='ptmitscs'>아동용좌석</label>

                                        <input
                                            type='checkbox'
                                            name='ptmitsfa'
                                            id='ptmitsfa'
                                            disabled
                                            value='Y'
                                            checked={detail?.PTMITSFA === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='ptmitsfa'>전면에어백</label>

                                        <input
                                            type='checkbox'
                                            name='ptmitssa'
                                            id='ptmitssa'
                                            disabled
                                            value='Y'
                                            checked={detail?.PTMITSSA === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='ptmitssa'>측면에어백</label>

                                        <input
                                            type='checkbox'
                                            name='ptmitshm'
                                            id='ptmitshm'
                                            disabled
                                            value='Y'
                                            checked={detail?.PTMITSHM === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='ptmitshm'>헬멧</label>

                                        <input
                                            type='checkbox'
                                            name='ptmitspt'
                                            id='ptmitspt'
                                            disabled
                                            value='Y'
                                            checked={detail?.PTMITSPT === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='ptmitspt'>무릎 및 관절보호대</label>

                                        <input
                                            type='checkbox'
                                            name='ptmietct'
                                            id='ptmietct'
                                            disabled
                                            value='Y'
                                            checked={detail?.PTMIETCT === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='ptmietct'>기타</label>

                                        <input
                                            type='checkbox'
                                            name='ptmitsno'
                                            id='ptmitsno'
                                            disabled
                                            value='Y'
                                            checked={detail?.PTMITSNO === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='ptmitsno'>전혀 착용안함</label>

                                        <input
                                            type='checkbox'
                                            name='ptmitsur'
                                            id='ptmitsur'
                                            disabled
                                            value='Y'
                                            checked={detail?.PTMITSUR === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='ptmitsur'>비해당</label>

                                        <input
                                            type='checkbox'
                                            name='ptmitsuk'
                                            id='ptmitsuk'
                                            disabled
                                            value='Y'
                                            checked={detail?.PTMITSUK === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='ptmitsuk'>미상</label>
                                    </td>
                                </tr>
                                <tr>
                                    <th>교통사고 <br />손상 당사자</th>
                                    <td>{detail?.TRMSTAIP}</td>
                                    <th>교통사고 시 <br />상대방 이송수단</th>
                                    <td colSpan='3'>{detail?.TRMSTAIO}</td>
                                </tr>
                                <tr>
                                    <th>직업 관련</th>
                                    <td colSpan={3}>
                                        {paynlist.map((item, index) => (
                                            <React.Fragment key={index}>
                                                <input
                                                    type='radio'
                                                    disabled
                                                    name='trmspayn'
                                                    id={`trmspayn${index + 1}`}
                                                    value={item.bscdminr}
                                                    checked={detail?.TRMSPAYN === item.bscdminr}
                                                    readOnly
                                                />
                                                <label htmlFor={`trmspayn${index + 1}`}>{item.bscddesc}</label>
                                            </React.Fragment>
                                        ))}
                                    </td>
                                    <th>직업</th>
                                    <td>{detail?.TRMSOCCU} ({detail?.TRMSOCTX})</td>
                                </tr>
                                <tr>
                                    <th>손상발생일시</th>
                                    <td>{detail?.TRMSHUDTM}</td>
                                    <th className='not_sent'>손상발생일시 <br />미상여부</th>
                                    <td>{detail?.TRMSHUUK}</td>
                                    <th>주증상 발생일시</th>
                                    <td>{detail?.TRMSMNDTM}</td>
                                </tr>
                                <tr>
                                    <th>사고발생지역</th>
                                    <td>{detail?.TRMSACA1} {detail?.TRMSACA2} {detail?.TRMSACA3}</td>
                                    <th>사고발생장소</th>
                                    <td colSpan='3'>{detail?.TRMSPLCE} ({detail?.TRMSPLTX})</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div id='bdtrms_damaged' className='trms_v_section'>
                        <div className='trms_v_subject mt-6'>&nbsp;4. 병원 전 정보</div>
                        <table summary='병원 전 정보'>
                            <colgroup>
                                <col width='15%' />
                                <col width='9%' />
                                <col width='9%' />
                                <col width='15%' />
                                <col width='18%' />
                                <col width='15%' />
                                <col width='18%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>신고일시</th>
                                    <td colSpan={2}>{detail?.TRMSRPDTM}</td>
                                    <th className='not_sent'>119구급활동일지 <br />일련번호</th>
                                    <td colSpan='3'>{detail?.PTMIREID}</td>
                                </tr>
                                <tr>
                                    <th>현장 도착일시</th>
                                    <td colSpan={2}>{detail?.TRMSARDTM}</td>
                                    <th>현장 출발일시</th>
                                    <td>{detail?.TRMSPDDTM}</td>
                                    <th className='not_sent'>현장체류시간</th>
                                    <td>{detail?.TRMSSYTM}</td>
                                </tr>
                                <tr>
                                    <th>초기현장 의식상태</th>
                                    <td colSpan='6'>
                                        {preslist.map((item, index) => (
                                            <React.Fragment key={index}>
                                                <input
                                                    type='radio'
                                                    disabled
                                                    name='trmspres'
                                                    id={`trmspres${index + 1}`}
                                                    value={item.bscdminr}
                                                    checked={detail?.TRMSPRES === item.bscdminr}
                                                    readOnly
                                                />
                                                <label htmlFor={`trmspres${index + 1}`}>{item.bscddesc}</label>
                                            </React.Fragment>
                                        ))}
                                    </td>
                                </tr>
                                <tr>
                                    <th>초기현장 활력징후</th>
                                    <td colSpan='6' className='p-0'>
                                        <table summary='활력징후' className='v_inner_table' >
                                            <colgroup>
                                                <col width='10%' />
                                                <col width='23%' />
                                                <col width='10%' />
                                                <col width='23%' />
                                                <col width='10%' />
                                                <col width='24%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>수축기 혈압</th>
                                                    <td>{detail?.TRMSPSBP}</td>
                                                    <th>이완기 혈압</th>
                                                    <td>{detail?.TRMSPDBP}</td>
                                                    <th>맥박</th>
                                                    <td>{detail?.TRMSPPLS}</td>
                                                </tr>
                                                <tr>
                                                    <th>호흡</th>
                                                    <td>{detail?.TRMSPBRT}</td>
                                                    <th>체온</th>
                                                    <td>{detail?.TRMSPBDH}</td>
                                                    <th>산소포화도</th>
                                                    <td>{detail?.TRMSPOXS}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='not_sent'>초기현장 GCS</th>
                                    <td colSpan='6' className='p-0'>
                                        <table summary='초기현장 GCS' className='v_inner_table' >
                                            <colgroup>
                                                <col width='10%' />
                                                <col width='23%' />
                                                <col width='10%' />
                                                <col width='23%' />
                                                <col width='10%' />
                                                <col width='24%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th className='not_sent'>눈</th>
                                                    <td>{detail?.TRMSPGCE || '-'}</td>
                                                    <th className='not_sent'>언어</th>
                                                    <td>{detail?.TRMSPGCV || '-'}</td>
                                                    <th className='not_sent'>언어(소아)</th>
                                                    <td>{detail?.TRMSPGCP || '-'}</td>
                                                </tr>
                                                <tr>
                                                    <th className='not_sent'>운동</th>
                                                    <td>{detail?.TRMSPGCM || '-'}</td>
                                                    <th className='not_sent'>전체</th>
                                                    <td colSpan='3'>{detail?.TRMSPGCT}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th rowSpan='11'>초기현장 <br />응급처치</th>
                                    <td colSpan='6'>
                                        {ptynlist.map((item, index) => (
                                            <React.Fragment key={index}>
                                                <input
                                                    type='radio'
                                                    disabled
                                                    name='trmsptyn'
                                                    id={`trmsptyn${index + 1}`}
                                                    value={item.bscdminr}
                                                    checked={detail?.TRMSPTYN === item.bscdminr}
                                                    readOnly
                                                />
                                                <label htmlFor={`trmsptyn${index + 1}`}>{item.bscddesc}</label>
                                            </React.Fragment>
                                        ))}
                                    </td>
                                </tr>
                                <tr>
                                    <td>기도확보</td>
                                    <td colSpan='5'>
                                        <input
                                            type='checkbox'
                                            name='trmspt11'
                                            id='trmspt11'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT11 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt11'>도수조작</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt12'
                                            id='trmspt12'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT12 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt12'>기도유지기</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt13'
                                            id='trmspt13'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT13 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt13'>후두마스크</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt14'
                                            id='trmspt14'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT14 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt14'>기도삽관</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt15'
                                            id='trmspt15'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT15 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt15'>흡인기</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt16'
                                            id='trmspt16'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT16 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt16'>기도폐쇄처치</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt17'
                                            id='trmspt17'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT17 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt17'>대체 기도 삽관</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <p>산소투여</p>
                                        <p className='not_sent px-1 w-fit'>({detail?.TRMSP20V} ℓ/min)</p>
                                    </td>
                                    <td colSpan='5'>
                                        <input
                                            type='checkbox'
                                            name='trmspt21'
                                            id='trmspt21'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT21 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt21'>비관</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt22'
                                            id='trmspt22'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT22 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt22'>안면마스크</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt23'
                                            id='trmspt23'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT23 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt23'>포켓마스크</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt24'
                                            id='trmspt24'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT24 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt24'>BVM</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt25'
                                            id='trmspt25'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT25 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt25'>산소소생기</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt26'
                                            id='trmspt26'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT26 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt26'>네뷸라이저</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt28'
                                            id='trmspt28'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT28 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt28'>비재호흡마스크</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt27'
                                            id='trmspt27'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT27 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt27'>기타 산소투여</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>CPR</td>
                                    <td colSpan='5'>
                                        <input
                                            type='checkbox'
                                            name='trmspt31'
                                            id='trmspt31'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT31 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt31'>실시</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt32'
                                            id='trmspt32'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT32 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt32'>거부</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt33'
                                            id='trmspt33'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT33 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt33'>DNR</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td>순환보조</td>
                                    <td colSpan='5'>
                                        <input
                                            type='checkbox'
                                            name='trmspt41'
                                            id='trmspt41'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT41 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt41'>정맥로 확보</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt42'
                                            id='trmspt42'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT42 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt42'>
                                            수액공급
                                            <span className='not_sent px-1'>({detail?.TRMSP42V} cc)확보</span>
                                        </label>

                                        <input
                                            type='checkbox'
                                            name='trmspt43'
                                            id='trmspt43'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT43 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt43'>MAST</label>
                                    </td>

                                </tr>
                                <tr>
                                    <td>고정</td>
                                    <td colSpan='5'>
                                        <input
                                            type='checkbox'
                                            name='trmspt51'
                                            id='trmspt51'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT51 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt51'>경추</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt52'
                                            id='trmspt52'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT52 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt52'>척추</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt53'
                                            id='trmspt53'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT53 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt53'>부목</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt54'
                                            id='trmspt54'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT54 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt54'>머리</label>
                                    </td>

                                </tr>
                                <tr>
                                    <td>상처처치</td>
                                    <td colSpan='5'>
                                        <input
                                            type='checkbox'
                                            name='trmspt61'
                                            id='trmspt61'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT61 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt61'>지혈</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt62'
                                            id='trmspt62'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT62 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt62'>상처드레싱</label>
                                    </td>

                                </tr>
                                <tr>
                                    <td>보온</td>
                                    <td colSpan='5'>
                                        <input
                                            type='checkbox'
                                            name='trmspt71'
                                            id='trmspt71'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT71 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt71'>온</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt72'
                                            id='trmspt72'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT72 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt72'>냉</label>
                                    </td>
                                </tr>

                                <tr>
                                    <td>AED</td>
                                    <td colSpan='5'>
                                        <input
                                            type='checkbox'
                                            name='trmspt81'
                                            id='trmspt81'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT81 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt81'>Shock</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt82'
                                            id='trmspt82'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT82 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt82'>Monitoring</label>
                                    </td>
                                </tr>

                                <tr>
                                    <td>기타</td>
                                    <td colSpan='5'>
                                        <input
                                            type='checkbox'
                                            name='trmspt01'
                                            id='trmspt01'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT01 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt01'>인공호흡</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt02'
                                            id='trmspt02'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT02 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt02'>과호흡처치</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt03'
                                            id='trmspt03'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT03 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt03'>ECG</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt04'
                                            id='trmspt04'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT04 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt04'>
                                            약물투여<span className='not_sent px-1'>({detail?.TRMSP04V})</span>
                                        </label>

                                        <input
                                            type='checkbox'
                                            name='trmspt05'
                                            id='trmspt05'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT05 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt05'>분만</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt06'
                                            id='trmspt06'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT06 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt06'>기타({detail?.TRMSP06V})</label>

                                        <input
                                            type='checkbox'
                                            name='trmspt09'
                                            id='trmspt09'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT09 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt09' className='not_sent px-1'>
                                            미상
                                        </label>

                                        <input
                                            type='checkbox'
                                            name='trmspt99'
                                            id='trmspt99'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSPT99 === 'Y'}
                                            readOnly
                                        />
                                        <label htmlFor='trmspt99' className='not_sent px-1'>
                                            시행하지않음
                                        </label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div id='bdtrms_sart' className='trms_v_section'>
                        <div className='trms_v_subject mt-6'>&nbsp;5. 기타정보</div>
                        <table summary='※ 기타정보'>
                            <colgroup>
                                <col width='15%' />
                                <col width='18%' />
                                <col width='15%' />
                                <col width='18%' />
                                <col width='15%' />
                                <col width='18%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>전원 보낼 정보</th>
                                    <td colSpan='5' className='p-0'>
                                        <table summary='전원 보낼 정보' className='v_inner_table' >
                                            <colgroup>
                                                <col width='18%' />
                                                <col width='18%' />
                                                <col width='18%' />
                                                <col width='18%' />
                                                <col width='18%' />
                                                <col width='18%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th className='nedis'>전원 보낼 <br />의료기관 종류</th>
                                                    <td>{detail?.PTMIDCTPDESC}</td>
                                                    <th className='nedis'>전원 보낼 <br />의료기관명</th>
                                                    <td>{detail?.PTMIDCCDDESC}</td>
                                                    <th className='not_sent'>전출의료기관명</th>
                                                    <td>{detail?.TRMSTHGT}</td>
                                                </tr>
                                                <tr>
                                                    <th>전원 보낼 <br />의료기관 출발일시</th>
                                                    <td>{detail?.TRMSTHDTM}</td>
                                                    <th>전원 보낼 시 <br />이송수단</th>
                                                    <td colSpan='3'>{detail?.TRMSTHTR} ({detail?.TRMSTHTX})</td>
                                                </tr>
                                                <tr>
                                                    <th>전원 보낼 의료기관<br />출발 시 동승인력 여부</th>
                                                    <td colSpan={5}>
                                                        {thpylist && thpylist.map((item, index) => (
                                                            <React.Fragment key={index}>
                                                                <input
                                                                    type='radio'
                                                                    disabled
                                                                    name='trmsthpy'
                                                                    id={`trmsthpy${index + 1}`}
                                                                    value={item.bscdminr}
                                                                    checked={detail?.TRMSTHPY === item.bscdminr}
                                                                    readOnly
                                                                />
                                                                <label htmlFor={`trmsthpy${index + 1}`}>{item.bscddesc}</label>
                                                            </React.Fragment>
                                                        ))}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>전원 보낼 의료기관<br />출발 시 동승인력</th>
                                                    <td colSpan={5}>
                                                        <input
                                                            type='checkbox'
                                                            name='trmsthp1'
                                                            id='trmsthp1'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSTHP1 === 'Y'}
                                                            readOnly
                                                        />
                                                        <label htmlFor='trmsthp1'>의사</label>

                                                        <input
                                                            type='checkbox'
                                                            name='trmsthp2'
                                                            id='trmsthp2'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSTHP2 === 'Y'}
                                                            readOnly
                                                        />
                                                        <label htmlFor='trmsthp2'>응급구조사 1급</label>

                                                        <input
                                                            type='checkbox'
                                                            name='trmsthp3'
                                                            id='trmsthp3'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSTHP3 === 'Y'}
                                                            readOnly
                                                        />
                                                        <label htmlFor='trmsthp3'>간호사</label>

                                                        <input
                                                            type='checkbox'
                                                            name='trmsthp4'
                                                            id='trmsthp4'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSTHP4 === 'Y'}
                                                            readOnly
                                                        />
                                                        <label htmlFor='trmsthp4'>기타({detail?.TRMSTHPX})</label>

                                                        <input
                                                            type='checkbox'
                                                            name='trmsthp5'
                                                            id='trmsthp5'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSTHP5 === 'Y'}
                                                            readOnly
                                                        />
                                                        <label htmlFor='trmsthp5' className='not_sent px-1'>미상</label>

                                                        <input
                                                            type='checkbox'
                                                            name='trmsthp6'
                                                            id='trmsthp6'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSTHP6 === 'Y'}
                                                            readOnly
                                                        />
                                                        <label htmlFor='trmsthp6' className='not_sent px-1'>없음</label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>전원 보낼 의료기관<br />사전 연락 유무</th>
                                                    <td>{detail?.TRMSTHCLDESC}</td>
                                                    <th>전원 보낼 의료기관<br />사전 연락 유무<br />기타 내용</th>
                                                    <td colSpan='3'>{detail?.TRMSTHCX}</td>
                                                </tr>
                                                <tr>
                                                    <th>전원 보내는 사유</th>
                                                    <td>{detail?.TRMSTHRS}</td>
                                                    <th>전원 보내는 사유<br />기타 내용</th>
                                                    <td colSpan='3'>{detail?.TRMSTHRX}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>사망 정보</th>
                                    <td colSpan='5' className='p-0'>
                                        <table summary='사망 정보' className='v_inner_table' >
                                            <colgroup>
                                                <col width='18%' />
                                                <col width='82%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>사망일시</th>
                                                    <td>{detail?.TRMSDDDTM}</td>
                                                </tr>
                                                <tr>
                                                    <th>사망진단 정보</th>
                                                    <td colSpan='3' className='p-0'>
                                                        <table summary='사망진단 정보' className='v_inner_table' >
                                                            <colgroup>
                                                                <col width='25%' />
                                                                <col width='25%' />
                                                                <col width='25%' />
                                                                <col width='25%' />
                                                            </colgroup>
                                                            <thead>
                                                                <tr>
                                                                    <th>사망진단코드</th>
                                                                    <th>진단명</th>
                                                                    <th>Description</th>
                                                                    <th>사망진단구분</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {emihdgdtlist && emihdgdtlist.length > 0 ? (
                                                                    emihdgdtlist.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td>{item.DGDTDIAG}</td>
                                                                            <td>{item.DIAGNAME}</td>
                                                                            <td>{item.DIAGDESC}</td>
                                                                            <td>{item.DGDTDGGB}</td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={5} className='text-center'>
                                                                            ※사망진단내역이 없습니다.
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th rowSpan='6'>최종 AIS</th>
                                    <td colSpan='5' className='p-0'>
                                        <table summary='두경부' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='55%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th colSpan='4'>두경부</th>
                                                </tr>
                                                <tr>
                                                    <th>코드</th>
                                                    <th>점수</th>
                                                    <th>부위</th>
                                                    <th>설명</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihaisilist1 && emihaisilist1.length > 0 ? (
                                                    emihaisilist1.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.AISICODE}</td>
                                                            <td>{item.AISMMARK}</td>
                                                            <td>{item.AISMSPOT}</td>
                                                            <td>{item.AISMDESC}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={4} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan='6' className='p-0'>
                                        <table summary='안면' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='55%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th colSpan='4'>안면</th>
                                                </tr>
                                                <tr>
                                                    <th>코드</th>
                                                    <th>점수</th>
                                                    <th>부위</th>
                                                    <th>설명</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihaisilist2 && emihaisilist2.length > 0 ? (
                                                    emihaisilist2.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.AISICODE}</td>
                                                            <td>{item.AISMMARK}</td>
                                                            <td>{item.AISMSPOT}</td>
                                                            <td>{item.AISMDESC}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={4} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan='6' className='p-0'>
                                        <table summary='흉부' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='55%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th colSpan='4'>흉부</th>
                                                </tr>
                                                <tr>
                                                    <th>코드</th>
                                                    <th>점수</th>
                                                    <th>부위</th>
                                                    <th>설명</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihaisilist3 && emihaisilist3.length > 0 ? (
                                                    emihaisilist3.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.AISICODE}</td>
                                                            <td>{item.AISMMARK}</td>
                                                            <td>{item.AISMSPOT}</td>
                                                            <td>{item.AISMDESC}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={4} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan='6' className='p-0'>
                                        <table summary='복부 및 골반 내 장기' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='55%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th colSpan='4'>복부 및 골반 내 장기</th>
                                                </tr>
                                                <tr>
                                                    <th>코드</th>
                                                    <th>점수</th>
                                                    <th>부위</th>
                                                    <th>설명</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihaisilist4 && emihaisilist4.length > 0 ? (
                                                    emihaisilist4.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.AISICODE}</td>
                                                            <td>{item.AISMMARK}</td>
                                                            <td>{item.AISMSPOT}</td>
                                                            <td>{item.AISMDESC}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={4} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan='6' className='p-0'>
                                        <table summary='사지 및 골반' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='55%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th colSpan='4'>사지 및 골반</th>
                                                </tr>
                                                <tr>
                                                    <th>코드</th>
                                                    <th>점수</th>
                                                    <th>부위</th>
                                                    <th>설명</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihaisilist5 && emihaisilist5.length > 0 ? (
                                                    emihaisilist5.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.AISICODE}</td>
                                                            <td>{item.AISMMARK}</td>
                                                            <td>{item.AISMSPOT}</td>
                                                            <td>{item.AISMDESC}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={4} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan='6' className='p-0'>
                                        <table summary='외부' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='15%' />
                                                <col width='55%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th colSpan='4'>외부</th>
                                                </tr>
                                                <tr>
                                                    <th>코드</th>
                                                    <th>점수</th>
                                                    <th>부위</th>
                                                    <th>설명</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihaisilist6 && emihaisilist6.length > 0 ? (
                                                    emihaisilist6.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{item.AISICODE}</td>
                                                            <td>{item.AISMMARK}</td>
                                                            <td>{item.AISMSPOT}</td>
                                                            <td>{item.AISMDESC}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan={4} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>최종 ISS</th>
                                    <td colSpan='5'>{detail?.TRMSCISS}</td>
                                </tr>
                                {/* <tr className='border_not_sent'>
                                    <th></th>
                                    <td></td>
                                    <th></th>
                                    <td></td>
                                    <th></th>
                                    <td></td>
                                </tr> */}
                            </tbody>
                        </table>
                    </div>

                    <div id='bdtrms_sart' className='trms_v_section'>
                        <div className='trms_v_subject mt-6'>&nbsp;6. 추적관찰정보[미전송]</div>
                        <table summary='자. 추적관찰정보[미전송]'>
                            <colgroup>
                                <col width='16%' />
                                <col width='18%' />
                                <col width='16%' />
                                <col width='18%' />
                                <col width='16%' />
                                <col width='18%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th className='not_sent'>추적관찰(6개월)<br />GOS</th>
                                    <td>{detail?.TRMSSAGO}</td>
                                    <th className='not_sent'>추적관찰(6개월)<br />사회복귀여부</th>
                                    <td>{detail?.TRMSSART}</td>
                                    <th className='not_sent'>추적관찰(6개월)<br />거주상태</th>
                                    <td>{detail?.TRMSSAHA}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='trms_v_wrapper'>
                    <div id='bdtrms_admission' className='trms_v_section'>
                        <div className='trms_v_subject'>&nbsp;7. 외상센터 내원정보</div>
                        <table summary='외상센터 내원정보'>
                            <colgroup>
                                <col width='16%' />
                                <col width='18%' />
                                <col width='16%' />
                                <col width='18%' />
                                <col width='16%' />
                                <col width='18%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th className='nedis'>내원일시</th>
                                    <td>{detail?.PTMIINDTM}</td>
                                    <th className='nedis'>내원경로</th>
                                    <td>{detail?.PTMIINRT}</td>
                                    <th className='nedis'>내원수단</th>
                                    <td>{detail?.PTMIINMN}</td>
                                </tr>
                                <tr>
                                    <th className='nedis'>보험유형</th>
                                    <td colSpan='5'>{detail?.PTMIIUKD}</td>
                                </tr>
                                <tr>
                                    <th>전원 보낸 정보</th>
                                    <td colSpan='5' className='p-0'>
                                        <table summary='전원 보낸 정보' className='v_inner_table' >
                                            <colgroup>
                                                <col width='18%' />
                                                <col width='16%' />
                                                <col width='16%' />
                                                <col width='18%' />
                                                <col width='16%' />
                                                <col width='18%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th className='nedis'>전원 보낸 <br />의료기관 종류</th>
                                                    <td>{detail?.TIEMDVNAME || '-'}</td>
                                                    <th className='nedis'>전원 보낸 <br />의료기관명</th>
                                                    <td>{detail?.PTMIINCDDESC || '-'}</td>
                                                    <th className='not_sent'>전입 의료기관명</th>
                                                    <td>{detail?.TRMSFHGT}</td>
                                                </tr>
                                                <tr>
                                                    <th>전원 보낸 <br />의료기관 출발일시</th>
                                                    <td colSpan='5'>
                                                        {detail?.TRMSSTDTM}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>전원 보낸 의료기관  <br />출발 시 동승인력 여부</th>
                                                    <td colSpan={2}>
                                                        {fhpylist.map((item, index) => (
                                                            <React.Fragment key={item.bscdminr}>
                                                                <input
                                                                    type='radio'
                                                                    disabled
                                                                    name='trmsfhpy'
                                                                    id={`trmsfhpy${index + 1}`}
                                                                    value={item.bscdminr}
                                                                    checked={detail?.TRMSFHPY === item.bscdminr}
                                                                    readOnly
                                                                />
                                                                <label htmlFor={`trmsfhpy${index + 1}`}>{item.bscddesc}</label>
                                                            </React.Fragment>
                                                        ))}
                                                    </td>
                                                    <th>전원 보낸 의료기관 <br />출발 시 동승인력</th>
                                                    <td colSpan={2}>
                                                        <input
                                                            type='checkbox'
                                                            name='trmsfhp1'
                                                            id='trmsfhp1'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSFHP1 === 'Y'}
                                                            readOnly
                                                        />
                                                        <label htmlFor='trmsfhp1'>의사</label>

                                                        <input
                                                            type='checkbox'
                                                            name='trmsfhp2'
                                                            id='trmsfhp2'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSFHP2 === 'Y'}
                                                            readOnly
                                                        />
                                                        <label htmlFor='trmsfhp2'>응급구조사 1급</label>

                                                        <input
                                                            type='checkbox'
                                                            name='trmsfhp3'
                                                            id='trmsfhp3'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSFHP3 === 'Y'}
                                                            readOnly
                                                        />
                                                        <label htmlFor='trmsfhp3'>간호사</label>

                                                        <input
                                                            type='checkbox'
                                                            name='trmsfhp4'
                                                            id='trmsfhp4'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSFHP4 === 'Y'}
                                                            readOnly
                                                        />
                                                        <label htmlFor='trmsfhp4'>기타 ({detail?.TRMSFHPX})</label>

                                                        <input
                                                            type='checkbox'
                                                            name='trmsfhp5'
                                                            id='trmsfhp5'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSFHP5 === 'Y'}
                                                            readOnly
                                                        />
                                                        <label htmlFor='trmsfhp5' className='not_sent px-1'>미상</label>

                                                        <input
                                                            type='checkbox'
                                                            name='trmsfhp6'
                                                            id='trmsfhp6'
                                                            disabled
                                                            value='Y'
                                                            checked={detail?.TRMSFHP6 === 'Y'}
                                                            readOnly
                                                        />
                                                        <label htmlFor='trmsfhp6' className='not_sent px-1'>없음</label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>전원 보낸 사유</th>
                                                    <td colSpan={2}>{detail?.TRMSFHRS || '-'}</td>
                                                    <th>전원 보낸 사유 <br />기타 내용</th>
                                                    <td colSpan={2}>{detail?.TRMSFHRX}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>내원 전</th>
                                    <td colSpan='5' className='p-0'>
                                        <table summary='내원 전' className='v_inner_table' >
                                            <colgroup>
                                                <col width='18%' />
                                                <col width='32%' />
                                                <col width='18%' />
                                                <col width='32%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>심정지 유무</th>
                                                    <td>{detail?.TRMSARYN}</td>
                                                    <th>보고 유무</th>
                                                    <td>{detail?.TRMSREYN}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>내원 시</th>
                                    <td colSpan='5' className='p-0'>
                                        <table summary='내원 시' className='v_inner_table' >
                                            <colgroup>
                                                <col width='18%' />
                                                <col width='32%' />
                                                <col width='18%' />
                                                <col width='32%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th className='nedis'>반응</th>
                                                    <td colSpan={3}>
                                                        {resplist.map((item, index) => (
                                                            <React.Fragment key={item.bscdminr}>
                                                                <input
                                                                    type='radio'
                                                                    disabled
                                                                    name='ptmiresp'
                                                                    id={`ptmiresp${index + 1}`}
                                                                    value={item.bscdminr}
                                                                    checked={detail?.PTMIRESP === item.bscdminr}
                                                                    readOnly
                                                                />
                                                                <label htmlFor={`ptmiresp${index + 1}`}>{item.bscddesc}</label>
                                                            </React.Fragment>
                                                        ))}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>호흡보조</th>
                                                    <td>
                                                        {vbralist.map((item, index) => (
                                                            <React.Fragment key={item.bscdminr}>
                                                                <input
                                                                    type='radio'
                                                                    disabled
                                                                    name='trmsvbra'
                                                                    id={`trmsvbra${index + 1}`}
                                                                    value={item.bscdminr}
                                                                    checked={detail?.TRMSVBRA === item.bscdminr}
                                                                    readOnly
                                                                />
                                                                <label htmlFor={`trmsvbra${index + 1}`}>{item.bscddesc}</label>
                                                            </React.Fragment>
                                                        ))}
                                                    </td>
                                                    <th>산소보충</th>
                                                    <td>
                                                        {voxalist.map((item, index) => (
                                                            <React.Fragment key={item.bscdminr}>
                                                                <input
                                                                    type='radio'
                                                                    disabled
                                                                    name='trmsvoxa'
                                                                    id={`trmsvoxa${index + 1}`}
                                                                    value={item.bscdminr}
                                                                    checked={detail?.TRMSVOXA === item.bscdminr}
                                                                    readOnly
                                                                />
                                                                <label htmlFor={`trmsvoxa${index + 1}`}>{item.bscddesc}</label>
                                                            </React.Fragment>
                                                        ))}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>활력징후</th>
                                                    <td colSpan='3' className='p-0'>
                                                        <table summary='활력징후' className='v_inner_table' >
                                                            <colgroup>
                                                                <col width='15%' />
                                                                <col width='35%' />
                                                                <col width='15%' />
                                                                <col width='35%' />
                                                            </colgroup>
                                                            <tbody>
                                                                <tr>
                                                                    <th className='nedis'>수축기 혈압</th>
                                                                    <td>{detail?.PTMIHIBP} mmhg</td>
                                                                    <th className='nedis'>이완기 혈압</th>
                                                                    <td>{detail?.PTMILOBP} mmhg</td>
                                                                </tr>
                                                                <tr>
                                                                    <th className='nedis'>맥박</th>
                                                                    <td>{detail?.PTMIPULS} 회/min</td>
                                                                    <th className='nedis'>호흡</th>
                                                                    <td>{detail?.PTMIBRTH} 회/min</td>
                                                                </tr>
                                                                <tr>
                                                                    <th className='nedis'>체온</th>
                                                                    <td>{detail?.PTMIBDHT} ℃</td>
                                                                    <th>산소포화도</th>
                                                                    <td>{detail?.TRMSVOXS} %</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>GCS</th>
                                                    <td colSpan='3' className='p-0'>
                                                        <table summary='GCS' className='v_inner_table' >
                                                            <colgroup>
                                                                <col width='15%' />
                                                                <col width='35%' />
                                                                <col width='15%' />
                                                                <col width='35%' />
                                                            </colgroup>
                                                            <tbody>
                                                                <tr>
                                                                    <th className='not_sent'>sedative 여부</th>
                                                                    <td>{detail?.TRMSINGS}</td>
                                                                    <th>눈</th>
                                                                    <td>{detail?.TRMSVGCE}</td>

                                                                </tr>
                                                                <tr>
                                                                    <th>언어</th>
                                                                    <td>{detail?.TRMSVGCV}</td>
                                                                    <th>언어(소아)</th>
                                                                    <td>{detail?.TRMSVGCP}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>운동</th>
                                                                    <td>{detail?.TRMSVGCM}</td>
                                                                    <th>총점</th>
                                                                    <td>{detail?.TRMSVGCT}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>GCS_평가 가능 여부</th>
                                                    <td colSpan={3}>
                                                        {ngt5list.map((item, index) => (
                                                            <React.Fragment key={item.bscdminr}>
                                                                <input
                                                                    type='radio'
                                                                    disabled
                                                                    name='trmsngt5'
                                                                    id={`trmsngt5_${index + 1}`}
                                                                    value={item.bscdminr}
                                                                    checked={detail?.TRMSINGT5 === item.bscdminr}
                                                                    readOnly
                                                                />
                                                                <label htmlFor={`trmsngt5_${index + 1}`}>{item.bscddesc}</label>
                                                            </React.Fragment>
                                                        ))}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>GCS_평가 불가능 사유</th>
                                                    <td colSpan='3' className='p-0'>
                                                        <table summary='GCS_평가 불가능 사유' className='v_inner_table' >
                                                            <colgroup>
                                                                <col width='25%' />
                                                            </colgroup>
                                                            <tbody>
                                                                <tr>
                                                                    <th>진정제 사용</th>
                                                                    <td>
                                                                        {ngt1list.map((item, index) => (
                                                                            <React.Fragment key={item.bscdminr}>
                                                                                <input
                                                                                    type='radio'
                                                                                    disabled
                                                                                    name='trmsingt1'
                                                                                    id={`trmsingt1_${index + 1}`}
                                                                                    value={item.bscdminr}
                                                                                    checked={detail?.TRMSINGT1 === item.bscdminr}
                                                                                    readOnly
                                                                                />
                                                                                <label htmlFor={`trmsingt1_${index + 1}`}>{item.bscddesc}</label>
                                                                            </React.Fragment>
                                                                        ))}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th>안대착용, 안검부종 등</th>
                                                                    <td>
                                                                        {ngt2list.map((item, index) => (
                                                                            <React.Fragment key={item.bscdminr}>
                                                                                <input
                                                                                    type='radio'
                                                                                    disabled
                                                                                    name='trmsingt2'
                                                                                    id={`trmsingt2_${index + 1}`}
                                                                                    value={item.bscdminr}
                                                                                    checked={detail?.TRMSINGT2 === item.bscdminr}
                                                                                    readOnly
                                                                                />
                                                                                <label htmlFor={`trmsingt2_${index + 1}`}>{item.bscddesc}</label>
                                                                            </React.Fragment>
                                                                        ))}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th>기관절개, 삽관 등</th>
                                                                    <td>
                                                                        {ngt3list.map((item, index) => (
                                                                            <React.Fragment key={item.bscdminr}>
                                                                                <input
                                                                                    type='radio'
                                                                                    disabled
                                                                                    name='trmsingt3'
                                                                                    id={`trmsingt3_${index + 1}`}
                                                                                    value={item.bscdminr}
                                                                                    checked={detail?.TRMSINGT3 === item.bscdminr}
                                                                                    readOnly
                                                                                />
                                                                                <label htmlFor={`trmsingt3_${index + 1}`}>{item.bscddesc}</label>
                                                                            </React.Fragment>
                                                                        ))}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>RTS</th>
                                                    <td>{detail?.TRMSRTSC}</td>
                                                    <th className='not_sent'>RTS_weighted</th>
                                                    <td>{detail?.TRMSRTSW}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>중증도<br />분류 정보</th>
                                    <td colSpan='5' className='p-0'>
                                        <table summary='중증도 분류 정보' className='v_inner_table'>
                                            <colgroup>
                                                <col width='18%' />
                                                <col width='32%' />
                                                <col width='18%' />
                                                <col width='32%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>최초 중증도 분류 일시</th>
                                                    <td>{detail?.PTMIKTDT}&nbsp;{detail?.PTMIKTTM}</td>
                                                    <th>최종진료구역</th>
                                                    <td>{detail?.PTMIAREADESC}</td>
                                                </tr>
                                                <tr>
                                                    <th>최초 중증도 분류 과정</th>
                                                    <td>{detail?.PTMIKPR1} ({detail?.PTMIKPR1CD})</td>
                                                    <th>최초 중증도 분류 결과</th>
                                                    <td>{detail?.PTMIKTS1DESC} ({detail?.PTMIKTS1})</td>
                                                </tr>
                                                <tr>
                                                    <th>최초 중증도 분류자 직종</th>
                                                    <td>{detail?.PTMIKJOBDESC}</td>
                                                    <th>최초 중증도 분류자 <br />면허 또는 자격번호</th>
                                                    <td>{detail?.PTMIKIDN}</td>
                                                </tr>
                                                <tr>
                                                    <th>변경된 중증도 분류 과정</th>
                                                    <td>{detail?.PTMIKPR2} ({detail?.PTMIKPR2CD})</td>
                                                    <th>변경된 중증도 분류 결과</th>
                                                    <td>{detail?.PTMIKTS2DESC} ({detail?.PTMIKTS2})</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div id='bdtrms_diagnosis' className='trms_v_section'>
                        <div className='trms_v_subject mt-6'>&nbsp;8. 외상센터 진료정보</div>
                        <table summary='외상센터 진료정보'>
                            <colgroup>
                                <col width='16%' />
                                <col width='18%' />
                                <col width='16%' />
                                <col width='18%' />
                                <col width='16%' />
                                <col width='18%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th className='nedis'>주증상</th>
                                    <td colSpan='5' className='p-0'>
                                        <table summary='주증상' className='v_inner_table' >
                                            <colgroup>
                                                <col width='11%' />
                                                <col width='12%' />
                                                <col width='22%' />
                                                <col width='18%' />
                                                <col width='18%' />
                                                <col width='18%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>증상코드 1</th>
                                                    <td>{detail?.PTMIMNSY}</td>
                                                    <th>UMLS preferred term</th>
                                                    <td>{detail?.SYPTPRTM}</td>
                                                    <th>Chief complaint</th>
                                                    <td>{detail?.SYPTCHCO}</td>
                                                </tr>
                                                <tr>
                                                    <th>증상코드 2</th>
                                                    <td>{detail?.PTMISYM2}</td>
                                                    <th>UMLS preferred term</th>
                                                    <td>{detail?.SYPTPRTM2}</td>
                                                    <th>Chief complaint</th>
                                                    <td>{detail?.SYPTCHCO2}</td>
                                                </tr>
                                                <tr>
                                                    <th>증상코드 3</th>
                                                    <td>{detail?.PTMISYM3}</td>
                                                    <th>UMLS preferred term</th>
                                                    <td>{detail?.SYPTPRTM3}</td>
                                                    <th>Chief complaint</th>
                                                    <td>{detail?.SYPTCHCO3}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>알코올 섭취</th>
                                    <td colSpan='5'>{detail?.TRMSALYN}</td>
                                </tr>
                                <tr>
                                    <th rowSpan='2'>기저질환</th>
                                    <td colSpan={5}>
                                        {bd32list.map((item, index) => (
                                            <React.Fragment key={item.bscdminr}>
                                                <input
                                                    type='radio'
                                                    disabled
                                                    name='trmsbd32'
                                                    id={`trmsbd32_${index + 1}`}
                                                    value={item.bscdminr}
                                                    checked={detail?.TRMSBD32 === item.bscdminr}
                                                    readOnly
                                                />
                                                <label htmlFor={`trmsbd32_${index + 1}`}>{item.bscddesc}</label>
                                            </React.Fragment>
                                        ))}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={5}>
                                        <input
                                            type='checkbox'
                                            name='trmsbd11'
                                            id='trmsbd11'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSBD11 === 'Y'}
                                            readOnly
                                        />
                                        <label>Myocardial Infarction</label>
                                        <label>
                                            <input
                                                type='checkbox'
                                                name='trmsbd12'
                                                id='trmsbd12'
                                                disabled
                                                value='Y'
                                                checked={detail?.TRMSBD12 === 'Y'}
                                                readOnly
                                            />
                                            Congestive Heart Failure
                                        </label>
                                        <label>
                                            <input
                                                type='checkbox'
                                                name='trmsbd13'
                                                id='trmsbd13'
                                                disabled
                                                value='Y'
                                                checked={detail?.TRMSBD13 === 'Y'}
                                                readOnly
                                            />
                                            Peripheral Vascular Disease
                                        </label>
                                        <label>
                                            <input
                                                type='checkbox'
                                                name='trmsbd14'
                                                id='trmsbd14'
                                                disabled
                                                value='Y'
                                                checked={detail?.TRMSBD14 === 'Y'}
                                                readOnly
                                            />
                                            Cerebrovascular Disease
                                        </label>
                                        <label>
                                            <input
                                                type='checkbox'
                                                name='trmsbd15'
                                                id='trmsbd15'
                                                disabled
                                                value='Y'
                                                checked={detail?.TRMSBD15 === 'Y'}
                                                readOnly
                                            />
                                            Dementia
                                        </label>
                                        <br />
                                        <label>
                                            <input
                                                type='checkbox'
                                                name='trmsbd16'
                                                id='trmsbd16'
                                                disabled
                                                value='Y'
                                                checked={detail?.TRMSBD16 === 'Y'}
                                                readOnly
                                            />
                                            COPD
                                        </label>
                                        <label>
                                            <input
                                                type='checkbox'
                                                name='trmsbd17'
                                                id='trmsbd17'
                                                disabled
                                                value='Y'
                                                checked={detail?.TRMSBD17 === 'Y'}
                                                readOnly
                                            />
                                            Connective Tissue Disease
                                        </label>
                                        <label>
                                            <input
                                                type='checkbox'
                                                name='trmsbd18'
                                                id='trmsbd18'
                                                disabled
                                                value='Y'
                                                checked={detail?.TRMSBD18 === 'Y'}
                                                readOnly
                                            />
                                            Peptic Ulcer Disease
                                        </label>
                                        <label>
                                            <input
                                                type='checkbox'
                                                name='trmsbd19'
                                                id='trmsbd19'
                                                disabled
                                                value='Y'
                                                checked={detail?.TRMSBD19 === 'Y'}
                                                readOnly
                                            />
                                            Diabetes Mellitus
                                        </label>
                                        <label>
                                            <input
                                                type='checkbox'
                                                name='trmsbd20'
                                                id='trmsbd20'
                                                disabled
                                                value='Y'
                                                checked={detail?.TRMSBD20 === 'Y'}
                                                readOnly
                                            />
                                            Moderate to Severe Chronic Kidney Disease
                                        </label>
                                        <br />
                                        <label>
                                            <input
                                                type='checkbox'
                                                name='trmsbd21'
                                                id='trmsbd21'
                                                disabled
                                                value='Y'
                                                checked={detail?.TRMSBD21 === 'Y'}
                                                readOnly
                                            />
                                            Hemiplegia
                                        </label>
                                        <label>
                                            <input
                                                type='checkbox'
                                                name='trmsbd22'
                                                id='trmsbd22'
                                                disabled
                                                value='Y'
                                                checked={detail?.TRMSBD22 === 'Y'}
                                                readOnly
                                            />
                                            Leukemia
                                        </label>
                                        <label>
                                            <input
                                                type='checkbox'
                                                name='trmsbd23'
                                                id='trmsbd23'
                                                disabled
                                                value='Y'
                                                checked={detail?.TRMSBD23 === 'Y'}
                                                readOnly
                                            />
                                            Malignant Lymphoma
                                        </label>
                                        <label>
                                            <input
                                                type='checkbox'
                                                name='trmsbd24'
                                                id='trmsbd24'
                                                disabled
                                                value='Y'
                                                checked={detail?.TRMSBD24 === 'Y'}
                                                readOnly
                                            />
                                            Solid Tumor
                                        </label>
                                        <label>
                                            <input
                                                type='checkbox'
                                                name='trmsbd25'
                                                id='trmsbd25'
                                                disabled
                                                value='Y'
                                                checked={detail?.TRMSBD25 === 'Y'}
                                                readOnly
                                            />
                                            Liver Disease
                                        </label>
                                        <br />
                                        <label>
                                            <input
                                                type='checkbox'
                                                name='trmsbd26'
                                                id='trmsbd26'
                                                disabled
                                                value='Y'
                                                checked={detail?.TRMSBD26 === 'Y'}
                                                readOnly
                                            />
                                            AIDS
                                        </label>
                                        <label>
                                            <input
                                                type='checkbox'
                                                name='trmsbd27'
                                                id='trmsbd27'
                                                disabled
                                                value='Y'
                                                checked={detail?.TRMSBD27 === 'Y'}
                                                readOnly
                                            />
                                            Bleeding disorder
                                        </label>
                                        <label>
                                            <input
                                                type='checkbox'
                                                name='trmsbd28'
                                                id='trmsbd28'
                                                disabled
                                                value='Y'
                                                checked={detail?.TRMSBD28 === 'Y'}
                                                readOnly
                                            />
                                            Angina
                                        </label>
                                        <label>
                                            <input
                                                type='checkbox'
                                                name='trmsbd29'
                                                id='trmsbd29'
                                                disabled
                                                value='Y'
                                                checked={detail?.TRMSBD29 === 'Y'}
                                                readOnly
                                            />
                                            Hypertension requiring medication
                                        </label>
                                        <label>
                                            <input
                                                type='checkbox'
                                                name='trmsbd30'
                                                id='trmsbd30'
                                                disabled
                                                value='Y'
                                                checked={detail?.TRMSBD30 === 'Y'}
                                                readOnly
                                            />
                                            Steroid use(Oral)
                                        </label>
                                        <br />
                                        <label>
                                            <input
                                                type='checkbox'
                                                name='trmsbd31'
                                                id='trmsbd31'
                                                disabled
                                                value='Y'
                                                checked={detail?.TRMSBD31 === 'Y'}
                                                readOnly
                                            />
                                            major psychiatric disorder
                                        </label>
                                        <input
                                            type='checkbox'
                                            name='trmsbd99'
                                            id='trmsbd99'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSBD99 === 'Y'}
                                            readOnly
                                        />
                                        <label className='not_sent px-1'>
                                            알 수 없음
                                        </label>
                                        <input
                                            type='checkbox'
                                            name='trmsbd09'
                                            id='trmsbd09'
                                            disabled
                                            value='Y'
                                            checked={detail?.TRMSBD09 === 'Y'}
                                            readOnly
                                        />
                                        <label className='not_sent px-1'>
                                            없음
                                        </label>
                                        <label>
                                            <input
                                                type='checkbox'
                                                name='trmsbd10'
                                                id='trmsbd10'
                                                disabled
                                                value='Y'
                                                checked={detail?.TRMSBD10 === 'Y'}
                                                readOnly
                                            />
                                            기타 ({detail?.TRMSBDTX})
                                        </label>
                                    </td>
                                </tr>
                                <tr>
                                    <th className='nedis'>주 진료과</th>
                                    <td colSpan='5'>{detail?.PTMIDEPT}</td>
                                </tr>
                                <tr>
                                    <th>전문의</th>
                                    <td colSpan='5' className='p-0'>
                                        <table summary='전문의' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='85%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>진료 여부</th>
                                                    <td>{detail?.PTMISDCD}</td>
                                                </tr>
                                                <tr>
                                                    <th>전문의 진료내역</th>
                                                    <td className='p-0'>
                                                        <table summary='전문의' className='v_inner_table' >
                                                            <colgroup>
                                                                <col width='25%' />
                                                                <col width='25%' />
                                                                <col width='25%' />
                                                                <col width='25%' />
                                                            </colgroup>
                                                            <thead>
                                                                <tr>
                                                                    <th>진료과목 코드</th>
                                                                    <th>진료과목 구분</th>
                                                                    <th>면허번호</th>
                                                                    <th>전문의 진료일시</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {emihsdmdlist && emihsdmdlist.length > 0 ? (
                                                                    emihsdmdlist.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td>{item.SDMDDEPT}</td>
                                                                            <td>{item.SDMDDIVI}</td>
                                                                            <td>{item.SDMDDRLC}</td>
                                                                            <td>{item.SDMDSDDTM}</td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={4} className='text-center'>
                                                                            ※ 진료내역이 없습니다.
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>외상팀</th>
                                    <td colSpan='5' className='p-0'>
                                        <table summary='외상팀' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='35%' />
                                                <col width='15%' />
                                                <col width='35%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>활성화팀 호출 여부</th>
                                                    <td>
                                                        {clynlist && clynlist.map((item, index) => (
                                                            <React.Fragment key={index}>
                                                                <input
                                                                    type='radio'
                                                                    disabled
                                                                    name='trmsclyn'
                                                                    id={`trmsclyn_${index + 1}`}
                                                                    value={item.bscdminr}
                                                                    checked={detail?.TRMSCLYN2 === item.bscdminr}
                                                                    readOnly
                                                                />
                                                                <label htmlFor={`trmsclyn_${index + 1}`}>{item.bscddesc}</label>
                                                            </React.Fragment>
                                                        ))}
                                                    </td>
                                                    <th className='not_sent'>호출일시</th>
                                                    <td>{detail?.TRMSCLDTM}</td>
                                                </tr>
                                                <tr>
                                                    <th>on-call 호출 여부</th>
                                                    <td colSpan={3}>
                                                        {onynlist && onynlist.map((item, index) => (
                                                            <React.Fragment key={index}>
                                                                <input
                                                                    type='radio'
                                                                    disabled
                                                                    name='trmsonyn'
                                                                    id={`trmsonyn_${index + 1}`}
                                                                    value={item.bscdminr}
                                                                    checked={detail?.TRMSONYN === item.bscdminr}
                                                                    readOnly
                                                                />
                                                                <label htmlFor={`trmsonyn_${index + 1}`}>{item.bscddesc}</label>
                                                            </React.Fragment>
                                                        ))}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>활성화 정보</th>
                                                    <td colSpan='3' className='p-0'>
                                                        <table summary='활성화 정보' className='v_inner_table' >
                                                            <colgroup>
                                                                <col width='12%' />
                                                                <col width='20%' />
                                                                <col width='20%' />
                                                                <col width='10%' />
                                                                <col width='10%' />
                                                                <col width='10%' />
                                                                <col width='11%' />
                                                            </colgroup>
                                                            <thead>
                                                                <tr>
                                                                    <th>구분</th>
                                                                    <th>호출일시</th>
                                                                    <th>도착일시</th>
                                                                    <th>면허번호</th>
                                                                    <th>성명</th>
                                                                    <th>진료과</th>
                                                                    <th>전담 여부</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {emihcltplist && emihcltplist.length > 0 ? (
                                                                    emihcltplist.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td>{item.CLTPCODEDESC}</td>
                                                                            <td>{item.CLTPCLDTM}</td>
                                                                            <td>{item.CLTPTEDTM}</td>
                                                                            <td>{item.CLTPTENO}</td>
                                                                            <td>{item.CLTPTENM}</td>
                                                                            <td>{item.CLTPDEPT}</td>
                                                                            <td>{item.CLTPDDCT}</td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={7} className='text-center'>
                                                                            ※ 활성화 내역이 없습니다.
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>최저혈압</th>
                                    <td colSpan={2}>수축(SBP) : {detail?.TRMSLSBP} mmhg, 이완(DBP) : {detail?.TRMSLDBP} mmhg</td>
                                    <th>평균 동맥압(MAP)</th>
                                    <td colSpan={3}>{detail?.TRMSTMAP} mmhg <span>( MAP = DBP+(SBP-DBP)/3 )</span></td>
                                </tr>
                                <tr>
                                    <th>퇴실 시</th>
                                    <td colSpan='5' className='p-0'>
                                        <table summary='퇴실 시' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='35%' />
                                                <col width='15%' />
                                                <col width='35%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>GCS</th>
                                                    <td colSpan='3' className='p-0'>
                                                        <table summary='GCS' className='v_inner_table' >
                                                            <colgroup>
                                                                <col width='15%' />
                                                                <col width='35%' />
                                                                <col width='15%' />
                                                                <col width='35%' />
                                                            </colgroup>
                                                            <tbody>
                                                                <tr>
                                                                    <th className='not_sent'>sedative 여부</th>
                                                                    <td>{detail?.TRMSOTGS}</td>
                                                                    <th>눈</th>
                                                                    <td>{detail?.TRMSOGCE}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>언어</th>
                                                                    <td>{detail?.TRMSOGCV}</td>
                                                                    <th>언어(소아)</th>
                                                                    <td>{detail?.TRMSOGCP}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>운동</th>
                                                                    <td>{detail?.TRMSOGCM}</td>
                                                                    <th>총점</th>
                                                                    <td>{detail?.TRMSOGCT}</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>GCS_평가 가능 여부</th>
                                                    <td colSpan={3}>
                                                        {ngn5list && ngn5list.map((item, index) => (
                                                            <React.Fragment key={index}>
                                                                <input
                                                                    type='radio'
                                                                    disabled
                                                                    name='trmsngn5'
                                                                    id={`trmsngn5_${index + 1}`}
                                                                    value={item.bscdminr}
                                                                    checked={detail?.TRMSONGN5 === item.bscdminr}
                                                                    readOnly
                                                                />
                                                                <label htmlFor={`trmsngn5_${index + 1}`}>{item.bscddesc}</label>
                                                            </React.Fragment>
                                                        ))}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>GCS_평가 불가능 사유</th>
                                                    <td colSpan='3' className='p-0'>
                                                        <table summary='GCS_평가 불가능 사유' className='v_inner_table' >
                                                            <colgroup>
                                                                <col width='25%' />
                                                            </colgroup>
                                                            <tbody>
                                                                <tr>
                                                                    <th>진정제 사용</th>
                                                                    <td>
                                                                        {ngn1list && ngn1list.map((item, index) => (
                                                                            <React.Fragment key={index}>
                                                                                <input
                                                                                    type='radio'
                                                                                    disabled
                                                                                    name='trmsongn1'
                                                                                    id={`trmsongn1_${index + 1}`}
                                                                                    value={item.bscdminr}
                                                                                    checked={detail?.TRMSONGN1 === item.bscdminr}
                                                                                    readOnly
                                                                                />
                                                                                <label htmlFor={`trmsongn1_${index + 1}`}>{item.bscddesc}</label>
                                                                            </React.Fragment>
                                                                        ))}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th>안대착용, 안검부종 등</th>
                                                                    <td>
                                                                        {ngn2list && ngn2list.map((item, index) => (
                                                                            <React.Fragment key={index}>
                                                                                <input
                                                                                    type='radio'
                                                                                    disabled
                                                                                    name='trmsongn2'
                                                                                    id={`trmsongn2_${index + 1}`}
                                                                                    value={item.bscdminr}
                                                                                    checked={detail?.TRMSONGN2 === item.bscdminr}
                                                                                    readOnly
                                                                                />
                                                                                <label htmlFor={`trmsongn2_${index + 1}`}>{item.bscddesc}</label>
                                                                            </React.Fragment>
                                                                        ))}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th>기관절개, 삽관 등</th>
                                                                    <td>
                                                                        {ngn3list && ngn3list.map((item, index) => (
                                                                            <React.Fragment key={index}>
                                                                                <input
                                                                                    type='radio'
                                                                                    disabled
                                                                                    name='trmsongn3'
                                                                                    id={`trmsongn3_${index + 1}`}
                                                                                    value={item.bscdminr}
                                                                                    checked={detail?.TRMSONGN3 === item.bscdminr}
                                                                                    readOnly
                                                                                />
                                                                                <label htmlFor={`trmsongn3_${index + 1}`}>{item.bscddesc}</label>
                                                                            </React.Fragment>
                                                                        ))}
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>퇴실정보</th>
                                    <td colSpan='5' className='p-0'>
                                        <table summary='퇴실정보' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='35%' />
                                                <col width='15%' />
                                                <col width='35%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th className='nedis'>퇴실일시</th>
                                                    <td>{detail?.PTMIOTDTM}</td>
                                                    <th className='nedis'>응급실진료결과</th>
                                                    <td>{detail?.PTMIEMRT}</td>
                                                </tr>
                                                <tr>
                                                    <th className='nedis'>퇴실 진단정보</th>
                                                    <td colSpan='3' className='p-0'>
                                                        <table summary='퇴실 진단정보' className='v_inner_table' >
                                                            <colgroup>
                                                                <col width='20%' />
                                                                <col width='30%' />
                                                                <col width='30%' />
                                                                <col width='20%' />
                                                            </colgroup>
                                                            <thead>
                                                                <tr>
                                                                    <th>퇴실진단코드</th>
                                                                    <th>진단명</th>
                                                                    <th>Description</th>
                                                                    <th>퇴실진단구분</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {emihdgotlist && emihdgotlist.length > 0 ? (
                                                                    emihdgotlist.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td>{item.DGOTDIAG}</td>
                                                                            <td>{item.DIAGNAME}</td>
                                                                            <td>{item.DIAGDESC}</td>
                                                                            <td>{item.DGOTDGGB}</td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={4} className='text-center'>
                                                                            ※ 퇴실진단내역이 없습니다.
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>입원 결정일시</th>
                                    <td>{detail?.TRMSATDTM}</td>
                                    <th className='not_sent'>입원결정<br />소요시간</th>
                                    <td>{detail?.TRMSATTT}</td>
                                    <th className='nedis'>입원경로</th>
                                    <td>{detail?.PTMIHSRT}</td>
                                </tr>
                                <tr>
                                    <th>입원 진료과</th>
                                    <td>{detail?.TRMSDQPTDESC}</td>
                                    <th>입원 결정 <br />전문의 성명</th>
                                    <td>{detail?.TRMSDQNM}</td>
                                    <th>입원 결정 <br />전문의 면허번호</th>
                                    <td>{detail?.TRMSDQNO}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div id='bdtrms_treatment' className='trms_v_section'>
                        <div className='trms_v_subject mt-6'>&nbsp;9. 환자검사 및 치료정보</div>
                        <table summary='사. 환자검사 및 치료정보'>
                            <colgroup>
                                <col width='10%' />
                                <col width='23%' />
                                <col width='10%' />
                                <col width='23%' />
                                <col width='10%' />
                                <col width='24%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>영상검사</th>
                                    <td colSpan='5' className='p-0'>
                                        <table summary='영상검사' className='v_inner_table' >
                                            <colgroup>
                                                <col width='7%' />
                                                <col width='9%' />
                                                <col width='13%' />
                                                <col width='13%' />
                                                <col width='13%' />
                                                <col width='9%' />
                                                <col width='9%' />
                                                <col width='9%' />
                                                <col width='9%' />
                                                <col width='9%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th rowSpan='2'>구분</th>
                                                    <th rowSpan='2'>종류</th>
                                                    <th rowSpan='2'>기타 내용</th>
                                                    <th rowSpan='2'>시행일시</th>
                                                    <th rowSpan='2'>판독결과 보고일시</th>
                                                    <th rowSpan='2'>판독결과</th>
                                                    <th className='text-center' colSpan='4'>FAST 양성 여부</th>
                                                </tr>
                                                <tr>
                                                    <th>흉부 체액저류</th>
                                                    <th>흉부 기흉</th>
                                                    <th>복부 체액저류</th>
                                                    <th>골반 체액저류</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihtrhtlist10 && emihtrhtlist10.length > 0 ? (
                                                    emihtrhtlist10.map((item, index) => {
                                                        if (item.TRHTVALU === '99') {
                                                            return (
                                                                <tr key={index}>
                                                                    <td colSpan={10} className='text-center'>
                                                                        실시안함
                                                                    </td>
                                                                </tr>
                                                            );
                                                        } else {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{item.TRHTINCDDESC}</td>
                                                                    <td>{item.TRHTVALU}</td>
                                                                    <td>{item.TRHTNMTX}</td>
                                                                    <td>{item.TRHTEXDTM}</td>
                                                                    <td>{item.TRHTEDDTM}</td>
                                                                    <td>{item.TRHTRDRT}</td>
                                                                    <td>{item.TRHTFAS1}</td>
                                                                    <td>{item.TRHTFAS2}</td>
                                                                    <td>{item.TRHTFAS3}</td>
                                                                    <td>{item.TRHTFAS4}</td>
                                                                </tr>
                                                            );
                                                        }
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={10} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>수술(시술)</th>
                                    <td colSpan='5' className='p-0'>
                                        <table summary='수술(시술)' className='v_inner_table' >
                                            <colgroup>
                                                <col width='7%' />
                                                <col width='14%' />
                                                <col width='14%' />
                                                <col width='9%' />
                                                <col width='14%' />
                                                <col width='14%' />
                                                <col width='14%' />
                                                <col width='14%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th>구분</th>
                                                    <th>입실일시</th>
                                                    <th>시행일시</th>
                                                    <th>수술(시술)구분</th>
                                                    <th>수술(시술)코드</th>
                                                    <th>수술(시술)명</th>
                                                    <th>시행의사 성명</th>
                                                    <th>시행의사 면허번호</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihtrhtlist20 && emihtrhtlist20.length > 0 ? (
                                                    emihtrhtlist20.map((item, index) => {
                                                        if (item.TRHTVALU === '99') {
                                                            return (
                                                                <tr key={index}>
                                                                    <td colSpan={8} className='text-center'>
                                                                        실시안함
                                                                    </td>
                                                                </tr>
                                                            );
                                                        } else {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{item.TRHTINCDDESC}</td>
                                                                    <td>{item.TRHTOPDTM}</td>
                                                                    <td>{item.TRHTEXDTM}</td>
                                                                    <td>{item.TRHTSEQVDESC}</td>
                                                                    <td>{item.TRHTVALU}</td>
                                                                    <td>{item.TRCDDESC}</td>
                                                                    <td>{item.TRHTDONM}</td>
                                                                    <td>{item.TRHTDONO}</td>
                                                                </tr>
                                                            );
                                                        }
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={8} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>인공호흡기</th>
                                    <td colSpan='5' className='p-0'>
                                        <table summary='인공호흡기' className='v_inner_table' >
                                            <colgroup>
                                                <col width='10%' />
                                                <col width='40%' />
                                                <col width='40%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th className='not_sent'>부착기간(분)</th>
                                                    <td colSpan='3'>{detail?.TRMSRSPR}</td>
                                                </tr>
                                                <tr>
                                                    <th>구분</th>
                                                    <th>부착일시</th>
                                                    <th>제거일시</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihtrhtlist40 && emihtrhtlist40.length > 0 ? (
                                                    emihtrhtlist40.map((item, index) => {
                                                        if (item.TRHTVALU === '99') {
                                                            return (
                                                                <tr key={index}>
                                                                    <td colSpan={3} className='text-center'>
                                                                        실시안함
                                                                    </td>
                                                                </tr>
                                                            );
                                                        } else {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{item.TRHTINCDDESC}</td>
                                                                    <td>{item.TRHTEXDTM}</td>
                                                                    <td>{item.TRHTEDDTM}</td>
                                                                </tr>
                                                            );
                                                        }
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={3} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>기관 내 삽관</th>
                                    <td colSpan='5' className='p-0'>
                                        <table summary='기관 내 삽관' className='v_inner_table' >
                                            <colgroup>
                                                <col width='10%' />
                                                <col width='40%' />
                                                <col width='40%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th>구분</th>
                                                    <th>기관 내 튜브 삽관일시</th>
                                                    <th>기관 내 튜브 제거일시</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihtrhtlist50 && emihtrhtlist50.length > 0 ? (
                                                    emihtrhtlist50.map((item, index) => {
                                                        if (item.TRHTVALU === '99') {
                                                            return (
                                                                <tr key={index}>
                                                                    <td colSpan={3} className='text-center'>
                                                                        실시안함
                                                                    </td>
                                                                </tr>
                                                            );
                                                        } else {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{item.TRHTINCDDESC}</td>
                                                                    <td>{item.TRHTEXDTM}</td>
                                                                    <td>{item.TRHTEDDTM}</td>
                                                                </tr>
                                                            );
                                                        }
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={3} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>수혈정보</th>
                                    <td colSpan='5' className='p-0'>
                                        <table summary='최저혈압 및 수혈정보' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='30%' />
                                                <col width='15%' />
                                                <col width='30%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th>최초 수혈 처방일시</th>
                                                    <td>{detail?.TRMSTODTM}</td>
                                                    <th>최초 수혈 시작일시</th>
                                                    <td>{detail?.TRMSTRDTM}</td>
                                                </tr>
                                                <tr>
                                                    <th>내원 4시간 내 수혈량</th>
                                                    <td colSpan='3' className='p-0'>
                                                        <table summary='내원 4시간 내 수혈량' className='v_inner_table' >
                                                            <colgroup>
                                                                <col width='15%' />
                                                                <col width='35%' />
                                                                <col width='15%' />
                                                                <col width='35%' />
                                                            </colgroup>
                                                            <tbody>
                                                                <tr>
                                                                    <th>적혈구(RBC)</th>
                                                                    <td>{detail?.TRMSITR1} pack</td>
                                                                    <th>혈장(plasma)</th>
                                                                    <td>{detail?.TRMSITR2} pack</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>혈소판(platelet)</th>
                                                                    <td>{detail?.TRMSITR3} pack</td>
                                                                    <th>전혈(whole blood)</th>
                                                                    <td>{detail?.TRMSITR4} pack</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>내원 24시간 내 추가 수혈량</th>
                                                    <td colSpan='3' className='p-0'>
                                                        <table summary='내원 24시간 내 추가 수혈량' className='v_inner_table' >
                                                            <colgroup>
                                                                <col width='15%' />
                                                                <col width='35%' />
                                                                <col width='15%' />
                                                                <col width='35%' />
                                                            </colgroup>
                                                            <tbody>
                                                                <tr>
                                                                    <th>적혈구(RBC)</th>
                                                                    <td>{detail?.TRMSOTR1} pack</td>
                                                                    <th>혈장(plasma)</th>
                                                                    <td>{detail?.TRMSOTR2} pack</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>혈소판(platelet)</th>
                                                                    <td>{detail?.TRMSOTR3} pack</td>
                                                                    <th>전혈(whole blood)</th>
                                                                    <td>{detail?.TRMSOTR4} pack</td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div id='bdtrms_medical' className='trms_v_section'>
                        <div className='trms_v_subject mt-6'>10. 입원 후 진료정보와 결과 정보</div>
                        <table summary='아. 입원 후 진료정보와 결과 정보'>
                            <colgroup>
                                <col width='10%' />
                                <col width='23%' />
                                <col width='10%' />
                                <col width='23%' />
                                <col width='10%' />
                                <col width='24%' />
                            </colgroup>
                            <tbody>
                                <tr>
                                    <th>중환자실 입원</th>
                                    <td colSpan='5' className='p-0'>
                                        <table summary='중환자실 입원' className='v_inner_table' >
                                            <colgroup>
                                                <col width='10%' />
                                                <col width='30%' />
                                                <col width='30%' />
                                                <col width='30%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th className='not_sent' colSpan='2'>중환자실 입원기간</th>
                                                    <td colSpan='2'>{detail?.TRMSVTPR}</td>
                                                </tr>
                                                <tr>
                                                    <th>구분</th>
                                                    <th>종류</th>
                                                    <th>입실일시</th>
                                                    <th>퇴실일시</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihtrhtlist30 && emihtrhtlist30.length > 0 ? (
                                                    emihtrhtlist30.map((item, index) => {
                                                        if (item.TRHTVALU === '99') {
                                                            return (
                                                                <tr key={index}>
                                                                    <td colSpan={4} className='text-center'>
                                                                        실시안함
                                                                    </td>
                                                                </tr>
                                                            );
                                                        } else {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{item.TRHTINCDDESC}</td>
                                                                    <td>{item.TRHTEXICDESC}</td>
                                                                    <td>{item.TRHTEXDTM}</td>
                                                                    <td>{item.TRHTEDDTM}</td>
                                                                </tr>
                                                            );
                                                        }
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={4} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th>일반병실 입실</th>
                                    <td colSpan='5' className='p-0'>
                                        <table summary='일반병실 입실' className='v_inner_table' >
                                            <colgroup>
                                                <col width='10%' />
                                                <col width='30%' />
                                                <col width='30%' />
                                                <col width='30%' />
                                            </colgroup>
                                            <thead>
                                                <tr>
                                                    <th>구분</th>
                                                    <th>종류</th>
                                                    <th>입실일시</th>
                                                    <th>퇴실일시</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emihtrhtlist31 && emihtrhtlist31.length > 0 ? (
                                                    emihtrhtlist31.map((item, index) => {
                                                        if (item.TRHTVALU === '99') {
                                                            return (
                                                                <tr key={index}>
                                                                    <td colSpan={4} className='text-center'>
                                                                        실시안함
                                                                    </td>
                                                                </tr>
                                                            );
                                                        } else {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>{item.TRHTINCDDESC}</td>
                                                                    <td>{item.TRHTEYICDESC}</td>
                                                                    <td>{item.TRHTEXDTM}</td>
                                                                    <td>{item.TRHTEDDTM}</td>
                                                                </tr>
                                                            );
                                                        }
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td colSpan={4} className='text-center'>
                                                            ※검색 내역이 없습니다.
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                                <tr>
                                    <th rowSpan='2'>합병증</th>
                                    <td colSpan={5}>
                                        {cp24list && cp24list.map((item, index) => (
                                            <React.Fragment key={item.bscdminr || index}>
                                                <input
                                                    type='radio'
                                                    disabled
                                                    name='trmscp24'
                                                    id={`trmscp24_${index + 1}`}
                                                    value={item.bscdminr}
                                                    checked={detail?.TRMSCP24 === item.bscdminr}
                                                    readOnly
                                                />
                                                <label htmlFor={`trmscp24_${index + 1}`}>{item.bscddesc}</label>
                                            </React.Fragment>
                                        ))}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={5}>
                                        {[
                                            { id: 'trmscp01', label: '없음' },
                                            { id: 'trmscp02', label: '급성신손상' },
                                            { id: 'trmscp03', label: '급성호흡곤란증후군' },
                                            { id: 'trmscp04', label: '심폐소생술을 시행한 심정지' },
                                            { id: 'trmscp05', label: '욕창' },
                                            { id: 'trmscp06', label: '깊은수술부위 감염' },
                                            { id: 'trmscp07', label: '약물 또는 알코올금단증후군' },
                                            { id: 'trmscp08', label: '심부정맥혈전증 혈전정맥염' },
                                            { id: 'trmscp09', label: '팔다리구획증후군' },
                                            { id: 'trmscp10', label: '이식,의치,피판수술실패' },
                                            { id: 'trmscp11', label: '심근경색증' },
                                            { id: 'trmscp12', label: '장기수술부위감염' },
                                            { id: 'trmscp13', label: '폐렴' },
                                            { id: 'trmscp14', label: '폐색전증' },
                                            { id: 'trmscp15', label: '뇌졸중' },
                                            { id: 'trmscp16', label: '표면적수술부위감염' },
                                            { id: 'trmscp17', label: '계획에 없던 기관삽관' },
                                            { id: 'trmscp18', label: '요로감염' },
                                            { id: 'trmscp19', label: 'catheter-related blood stream Infection' },
                                            { id: 'trmscp20', label: '골수염' },
                                            { id: 'trmscp21', label: 'unplanned return to the OR' },
                                            { id: 'trmscp22', label: 'unplanned return to the ICU' },
                                            { id: 'trmscp23', label: 'severe sepsis' }
                                        ].map(({ id, label }, index) => (
                                            <React.Fragment key={id}>
                                                <input
                                                    type='checkbox'
                                                    name={id}
                                                    id={id}
                                                    disabled
                                                    value='Y'
                                                    checked={detail && detail[id] === 'Y'}
                                                    readOnly
                                                />
                                                <label htmlFor={id} className={id === 'trmscp01' ? 'not_sent px-1' : ''}>
                                                    {label}
                                                </label>
                                                {(index === 4 || index === 9 || index === 14 || index === 19) && <br />}
                                            </React.Fragment>
                                        ))}
                                    </td>
                                </tr>
                                <tr>
                                    <th className='nedis'>입원 후 결과</th>
                                    <td colSpan='5'>{detail?.PTMIDCRT}</td>
                                </tr>
                                <tr>
                                    <th>퇴원정보</th>
                                    <td colSpan='5' className='p-0'>
                                        <table summary='퇴원정보' className='v_inner_table' >
                                            <colgroup>
                                                <col width='15%' />
                                                <col width='35%' />
                                                <col width='15%' />
                                                <col width='35%' />
                                            </colgroup>
                                            <tbody>
                                                <tr>
                                                    <th className='nedis'>퇴원일시</th>
                                                    <td>{detail?.PTMIDCDTM}</td>
                                                    <th>퇴원 시 GOS</th>
                                                    <td>{detail?.TRMSTGOS}</td>
                                                </tr>
                                                <tr>
                                                    <th className='nedis'>퇴원진단 정보</th>
                                                    <td colSpan='3' className='p-0'>
                                                        <table summary='퇴원진단 정보' className='v_inner_table' >
                                                            <colgroup>
                                                                <col width='20%' />
                                                                <col width='30%' />
                                                                <col width='30%' />
                                                                <col width='20%' />
                                                            </colgroup>
                                                            <thead>
                                                                <tr>
                                                                    <th>퇴원진단코드</th>
                                                                    <th>진단명</th>
                                                                    <th>Description</th>
                                                                    <th>퇴원진단구분</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {emihdgdclist && emihdgdclist.length > 0 ? (
                                                                    emihdgdclist.map((item, index) => (
                                                                        <tr key={index}>
                                                                            <td>{item.DGDCDIAG}</td>
                                                                            <td>{item.DIAGNAME}</td>
                                                                            <td>{item.DIAGDESC}</td>
                                                                            <td>{item.DGDCDGGB}</td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr>
                                                                        <td colSpan={4} className='text-center'>
                                                                            ※퇴원진단내역이 없습니다.
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default TrmsV3_popup;